// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const versionInfo = {
    "version": "1.0.0",
    "hash": "83ba9f90",
    "commitDate": "1780606135"
};
/* tslint:enable */
